import { PeopleBadge, ReportBadge, SearchBadgeLg } from "@dreamhub/designsystem/icons";

export const TRANSLATION_PREFIX = "meetingPrep";

// Tab-strip order; TabId/TAB_IDS derive from it. Badges: 91x98 family only.
export const TAB_CONFIG = {
  overview: { emptyIllustration: ReportBadge },
  keyPeople: { emptyIllustration: PeopleBadge },
  recentNews: { emptyIllustration: SearchBadgeLg }
};

export type TabId = keyof typeof TAB_CONFIG;

export const TAB_IDS = Object.keys(TAB_CONFIG) as TabId[];
